import React from 'react'

export const Guest = () =>{
    return (
        <ul className="guest">
            <li onClick={e =>{
                    e.preventDefault()
                }}>
                <img src="/assets/images/faces/default.svg" alt="default" />
                <p>Sign in</p>
            </li>
            <li className="order">
                <a href="/signin">
                    <a href="/projects/create">
                        <p>Create Project</p>
                    </a>
                </a>
            </li>
        </ul>
    )
}